import axios from 'axios';

let accessToken = localStorage.getItem('token');
let refreshPromise = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token, { removeLegacy = false } = {}) {
  accessToken = token || null;
  if (removeLegacy) localStorage.removeItem('token');
}

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const isAuthAction = original?.url?.includes('/auth/login') || original?.url?.includes('/auth/refresh');

    if (err.response?.status === 401 && original && !original._retry && !isAuthAction) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = axios.post('/api/auth/refresh', {}, { withCredentials: true })
            .finally(() => { refreshPromise = null; });
        }
        const refresh = await refreshPromise;
        setAccessToken(refresh.data.token, { removeLegacy: true });
        original.headers.Authorization = `Bearer ${refresh.data.token}`;
        return api(original);
      } catch (refreshError) {
        setAccessToken(null, { removeLegacy: true });
        window.dispatchEvent(new Event('auth:expired'));
      }
    }
    return Promise.reject(err);
  }
);

export default api;
